module.exports = __webpack_public_path__ + "static/media/117.d498ab98.jpg";